import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";

export const Footer = () => {
  const { t, tr } = useLang();
  const { settings: s } = useSite();
  const col = "font-sans text-[11px] tracking-[0.3em] uppercase text-gold mb-6";
  const lnk = "block text-sm text-ivory/75 hover:text-gold transition-colors mb-3";
  return (
    <footer data-testid="site-footer" className="bg-midnight text-ivory relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo size="md" />
            <p className="mt-8 font-display italic text-xl text-ivory/85 max-w-xs">{t.slogan}</p>
            <p className="mt-4 text-sm text-ivory/60 max-w-xs" data-testid="footer-text">{tr(s.footer_text)}</p>
          </div>
          <div className="md:col-span-2">
            <div className={col}>{t.footer.nav}</div>
            {[["/nehnutelnosti", "properties"], ["/destinacie", "destinations"], ["/spolupraca", "partner"], ["/blog", "blog"], ["/o-nas", "about"], ["/kontakt", "contact"]].map(([to, k]) => (
              <Link key={to} to={to} className={lnk} data-testid={`footer-nav-${k}`}>{t.nav[k] || "Blog"}</Link>
            ))}
          </div>
          <div className="md:col-span-3">
            <div className={col}>{t.footer.legal}</div>
            <Link to="/obchodne-podmienky" className={lnk} data-testid="footer-terms">{t.footer.terms}</Link>
            <Link to="/gdpr" className={lnk} data-testid="footer-gdpr">{t.footer.gdpr}</Link>
            <Link to="/cookies" className={lnk} data-testid="footer-cookies">{t.footer.cookies}</Link>
          </div>
          <div className="md:col-span-3" data-testid="footer-contact">
            <div className={col}>{t.footer.contact}</div>
            <p className="text-sm text-ivory/75 mb-3 whitespace-pre-line">{s.company}{s.address ? `\n${s.address}` : ""}</p>
            {s.phone && <a href={`tel:${s.phone}`} className={lnk}>{s.phone}</a>}
            {s.email && <a href={`mailto:${s.email}`} className={lnk}>{s.email}</a>}
            {s.company_id && <p className="text-xs text-ivory/55">{s.company_id}</p>}
            <div className="flex gap-4 mt-6">
              {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-ivory/75 hover:text-gold"><Instagram size={18} strokeWidth={1.3} /></a>}
              {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="text-ivory/75 hover:text-gold"><Facebook size={18} strokeWidth={1.3} /></a>}
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-ivory/55">
          <span>© {new Date().getFullYear()} MEVALUX PROPERTY. {t.footer.rights}</span>
          <span className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span data-testid="footer-operator">{t.footer.operator || "Operator"}: <a href="https://reallia.sk" target="_blank" rel="noreferrer" className="text-ivory/80 hover:text-gold transition-colors">REALLIA.sk</a></span>
            <span data-testid="footer-made-by">{t.footer.madeBy || "Created by"} <a href="https://4uweb.cz" target="_blank" rel="noreferrer" className="text-ivory/80 hover:text-gold transition-colors">4uweb.cz</a></span>
            <Link to="/admin" data-testid="footer-admin-link" className="tracking-[0.2em] uppercase hover:text-gold transition-colors">Administrácia</Link>
            <span className="tracking-[0.2em]">MEVALUXPROPERTY.COM</span>
          </span>
        </div>
      </div>
    </footer>
  );
};
